import { ROUTE_PATHS } from '../../routes/consts';
import { RoutePath } from '../../routes/types';
import { spawn } from '../../utils/translations';

/**
 * Returns a mapping of route paths to their localized display names
 * Used for generating breadcrumb labels and navigation items
 *
 * Implemented as a function to ensure translations are loaded when accessed
 */
export const getRouteMapping = (): Partial<Record<RoutePath, string>> => {
  const spawnItem = spawn('sidebar.item');

  return {
    [ROUTE_PATHS.INSTALLATION]: spawnItem('installation'),
    [ROUTE_PATHS.INTEGRATIONS]: spawnItem('integrations'),
    [ROUTE_PATHS.CONFIGURATION]: spawnItem('configuration'),
    [ROUTE_PATHS.MONITOR]: spawnItem('monitor'),
    [ROUTE_PATHS.HOME]: spawnItem('home'),
    [ROUTE_PATHS.ORGANIZATION]: spawnItem('organization'),
    [ROUTE_PATHS.PLANS]: spawnItem('plans'),
    [ROUTE_PATHS.TEAM]: spawnItem('team'),
    [ROUTE_PATHS.TEAMS_MANAGEMENT]: spawnItem('team'),
    [ROUTE_PATHS.ANALYTICS]: spawnItem('analytics'),
    [ROUTE_PATHS.EXTENSIONS]: spawnItem('extensions'),
    [ROUTE_PATHS.USERS]: spawnItem('users'),
    [ROUTE_PATHS.RULES]: spawnItem('review-standards'),
    [ROUTE_PATHS.FINDINGS]: spawnItem('findings'),
    [ROUTE_PATHS.TEAM_PROFILES]: spawnItem('team-profiles'),
    [ROUTE_PATHS.BILLING]: spawnItem('billing'),
    [ROUTE_PATHS.ACCOUNT]: spawnItem('account'),
    [ROUTE_PATHS.MANAGEMENT_REPOSITORIES]: spawnItem('repositories'),
    [ROUTE_PATHS.WIKI]: spawnItem('wiki'),
    [ROUTE_PATHS.SANDBOX_CONFIG]: spawnItem('sandbox-config'),
  };
};

/**
 * Returns a mapping of route paths to their badge labels
 */
export const getBadgeLabelMapping = (): Partial<Record<RoutePath, string>> => {
  const spawnItem = spawn('general');

  return {
    [ROUTE_PATHS.RULES]: spawnItem('beta'),
    [ROUTE_PATHS.TEAM_PROFILES]: spawnItem('alpha'),
    [ROUTE_PATHS.WIKI]: spawnItem('alpha'),
  };
};
